import {kAboutTeamTexts} from "../../../constants/texts";
import {aboutScreenHighlightWords} from "../../../helpers/StringHelper";
import {kHachetteLink, kMathLabLink} from "../../../constants/links";

export default function AboutTeamSection() {
    // Used in AboutContent to display team tab

    // BUILD
    return(
        <div className={"animate-appearSlow w-full flex flex-col space-y-[24px] text-[18px] text-greyLight9 font-normal pb-[40px]"}>
            {/** GEO */}
            <div className={"flex flex-col justify-start items-start space-y-[12px] mt-[24px]"}>
                <span className={"text-white font-medium"}>
                    {kAboutTeamTexts.geoName}
                </span>
                <div>
                    <span className={""}>
                        {aboutScreenHighlightWords(kAboutTeamTexts.geoOne, ['Professeur de mathématiques', 'formateur d’enseignants', 'auteur'])}
                    </span>
                    <a className={"text-primaryLight2 hover:underline"}
                       href={kHachetteLink}
                       target="_blank"
                       rel="noopener noreferrer">
                        {kAboutTeamTexts.geoTwo}
                    </a>
                    <span>
                        {aboutScreenHighlightWords(kAboutTeamTexts.geoThree, [])}
                    </span>
                    <a className={"text-primaryLight2 hover:underline"}
                       href={kMathLabLink}
                       target="_blank"
                       rel="noopener noreferrer">
                        {kAboutTeamTexts.geoFour}
                    </a>
                    <span>
                        {aboutScreenHighlightWords(kAboutTeamTexts.geoFive, ['tous les élèves peuvent réussir en mathématiques'])}
                    </span>
                </div>
            </div>
            {/** MARGOT */}
            <div className={"flex flex-col justify-start items-start space-y-[12px] mt-[24px]"}>
                <span className={"text-white font-medium"}>
                    {kAboutTeamTexts.margotName}
                </span>
                <div>
                    <span className={""}>
                        {aboutScreenHighlightWords(kAboutTeamTexts.margot, ['Responsable communication', 'conçoit et réalise les contenus', 'connaître', 'référence chez les collégiens'])}
                    </span>
                </div>
            </div>
            {/** CHLOE */}
            <div className={"flex flex-col justify-start items-start space-y-[12px] mt-[24px]"}>
                <span className={"text-white font-medium"}>
                    {kAboutTeamTexts.chloeName}
                </span>
                <div>
                    <span className={""}>
                        {aboutScreenHighlightWords(kAboutTeamTexts.chloe, ['Designeuse', "l'expérience utilisateur", 'rendre', 'plus intuitive possible pour les enfants'])}
                    </span>
                </div>
            </div>
            {/** QUENTIN */}
            <div className={"flex flex-col justify-start items-start space-y-[12px] mt-[24px]"}>
                <span className={"text-white font-medium"}>
                    {kAboutTeamTexts.quentinName}
                </span>
                <div>
                    <span className={""}>
                        {aboutScreenHighlightWords(kAboutTeamTexts.quentin, ['professeur de mathématiques', 'pédagogie', "développeur d'applications web et mobile", 'outil numérique interactif', 'clé'])}
                    </span>
                </div>
            </div>
        </div>
    );
}